import React from 'react';
import { createStyleSheet } from '../../../../utils';
import { useStyleSheet } from '../../../../hooks';
import { Text as UIText } from '../../../Text';
import { Entity } from './Entity';
import { List } from './List';
import { Text } from './Text';
import { Platform } from 'react-native';
export const TextBlock = ({ data, style, numberOfLines }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(UIText, Object.assign({ type: 'body', size: 'md', weight: 'regular', style: [styles.container, style] }, (numberOfLines ? { numberOfLines } : {})), data.map((item, index) => (React.createElement(React.Fragment, { key: index }, item.type === 'list' ? (React.createElement(List, Object.assign({}, item))) : item.type === 'entity' ? (React.createElement(Entity, Object.assign({}, item))) : (React.createElement(Text, Object.assign({}, item))))))));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    container: Object.assign({ color: color.invert2.p100 }, (Platform.OS === 'web' ? { paddingVertical: size.B } : {})),
    link: {
        color: color.primary.solid,
        textDecorationLine: 'underline'
    }
}));
//# sourceMappingURL=index.js.map